import { Youtube } from 'lucide-react';
import { cx } from './cx';

export interface YouTubeChannelLinkProps {
  channelId: string;
  name: string;
  className?: string;
}

const YouTubeChannelLink: React.FC<YouTubeChannelLinkProps> = ({ channelId, name, className }) => (
  <a
    href={`https://www.youtube.com/channel/${channelId}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={`Open ${name} on YouTube`}
    onClick={(e) => e.stopPropagation()}
    className={cx(
      'inline-flex items-center justify-center w-8 h-8 rounded-full transition-all duration-200 text-current hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-meradio-primary',
      className
    )}
  >
    <Youtube className="w-4 h-4" />
  </a>
);

export default YouTubeChannelLink;
